// 系统管理路由

const SystemMana = [
    // 账号管理
    {
        path: '/role',
        component: resolve => require(['@/views/SystemMana/RoleMana/RoleMana'], resolve),
        name: 'role',
        meta: { title: '账号管理',  breadcrumb: [{ menu: 'role' }], role: 'system' }
    },
    // 权限控制
    {
        path: '/authority',
        component: resolve => require(['@/views/SystemMana/AuthoritySetting/AuthoritySetting'], resolve),
        name: 'authority',
        meta: { title: '权限控制',  breadcrumb: [{ menu: 'authority' }], role: 'system' }
    },
    // 日志管理
    {
        path: '/logmanage',
        component: resolve => require(['@/views/SystemMana/LogMana/LogMana'], resolve),
        name: 'logmanage',
        meta: { title: '日志管理',  breadcrumb: [{ menu: 'logmanage' }], role: 'account' }
    },
	// 售后服务
	{
	    path: '/aftersales',
	    component: resolve => require(['@/views/SystemMana/AfterSales/AfterSales'], resolve),
	    name: 'aftersales',
	    meta: { title: '售后服务',  breadcrumb: [{ menu: 'aftersales' }], role: '' }
	},
];

export default SystemMana